import { createIcon } from '../../core/utils/uni-icon.js';
import type { DataViewUILogicBaseConstructor } from '../../core/view/data-view-base.js';
import { calendarViewModel } from './define.js';
import { CalendarViewUILogic } from './pc/calendar-view-ui-logic.js';

const calendarPcLogic =
  CalendarViewUILogic as unknown as DataViewUILogicBaseConstructor;

export const calendarViewMeta = calendarViewModel.createMeta({
  icon: createIcon('DateTimeIcon'),
  pcLogic: () => calendarPcLogic,
});
